import { Add, Edit, Delete } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { CustomerStopCodeDialog } from "./CustomerStopCodeDialog";
import { useCustomerFlagTypes } from "../../common/enum";
import { CustomerStopCodeDto } from "./types";

export function CustomerStopCodeListPage() {
    const [useStore] = useState(() => createListStore<CustomerStopCodeDto>({
        path: "settings/customerStopCodes",
        itemsPerPage: 15,
        listProps: [
            { column: "id", label: "Id", width: 80 },
            { column: "code", label: "Code", width: 80 },
            { column: "isActive", label: "Active", width: 100, type: "bool" },
            { column: "type", label: "Type", width: 150, enumStore: useCustomerFlagTypes },
            { column: "name", label: "Name", flex: 1 },
        ],
    }));

    const simpleDialog = useSimpleDialog();

    const { selectedCode } = useStore(p => ({ selectedCode: p.selectedItem }));
    async function deleteCode() {
        await simpleDialog.show("Customer stop code", "Delete selected customer stop code?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/customerStopCodes/${selectedCode?.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <CustomerStopCodeDialog close={close} customerStopCode={null}
        useListStore={useStore} />, "xs");
    const editDialog = useDialog(close => <CustomerStopCodeDialog close={close} customerStopCode={selectedCode!}
        useListStore={useStore} />, "xs");

    return <>
        {simpleDialog.render()}
        {newDialog.render()}
        {editDialog.render()}
        <PageTitle title="Customer stop codes" />
        <Grid container maxWidth="md">
            {renderListStore(useStore, {
                onDoubleClick: () => {
                    editDialog.show();
                }, header: listHeaderItems([
                    ["edit", () => <Button color="edit" disabled={selectedCode == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                    ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                    ["remove", () => <Button color="delete" disabled={selectedCode == null} title="Delete" onClick={deleteCode}><Delete /></Button>],
                ]),
            })}
        </Grid>
    </>;
}
